import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty } from "lodash";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import DeleteDisclaimerModal from "./delete-disclaimer-modal.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DisclaimersTable",
  components: {
    InlinePrompt,
    DeleteDisclaimerModal
  },
  props: {
    disclaimers: {
      type: Array,
      default: () => []
    },
    defaultDisclaimerEnabled: {
      type: Boolean,
      required: true
    },
    isBrokerage: {
      type: Boolean
    }
  },
  data() {
    return {
      columns: ["enabled", "message", "document", "mandatory", "actions"]
    };
  },
  computed: {
    isEmptyData() {
      return isEmpty(this.disclaimers);
    },
    options() {
      return {
        filterable: false,
        showChildRowToggler: false,
        headings: {
          enabled: `${this.$t("global.words.enabled")}?`,
          message: this.$t("settings.disclaimers.disclaimerMessageTitle"),
          document: this.$t("settings.disclaimers.linkedDocument"),
          mandatory: `${this.$t("global.words.mandatory")}?`,
          actions: "nodisplay"
        },
        sortable: [],
        tabbable: false,
        columnsClasses: {
          enabled: "text-center",
          message: "w-75",
          mandatory: "text-center"
        },
        skin: "table table-hover",
        perPage: 99999
      };
    }
  },
  methods: {
    showPreviewer({
      fileName,
      documentId
    }) {
      this.$emit("show-document-previewer", {
        fileName,
        documentId
      });
    },
    handleRemove(row) {
      this.$emit("delete-disclaimer", {
        disclaimer: row
      });
    },
    handleDeleteConfirmation(defaultDisclaimerEnabled) {
      this.$emit("delete-disclaimer", {
        disclaimer: this.disclaimerToDelete,
        defaultDisclaimerEnabled
      });
      this.$refs.deleteDisclaimerModal.$refs.modal.hide();
    },
    toggleDisclaimerProperty(row, property) {
      this.$emit("update-disclaimer", _objectSpread(_objectSpread({}, row), {}, {
        [property]: !row[property]
      }));
    },
    showDeleteDisclaimerModal(row) {
      this.disclaimerToDelete = row;
      this.$refs.deleteDisclaimerModal.$refs.modal.show();
    }
  }
});